import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['dialog', 'scroller'];

    connect() {
        document.body.classList.add('cart-rec-modal-open');

        if (this.element.classList.contains('is-open')) {
            return;
        }

        requestAnimationFrame(() => this.element.classList.add('is-open'));
    }

    disconnect() {
        if (!document.querySelector('.cart-rec-modal')) {
            document.body.classList.remove('cart-rec-modal-open');
        }
    }

    close() {
        this.element.classList.remove('is-open');
        setTimeout(() => this.element.remove(), 220);
    }

    backdropClose(event) {
        if (event.target === this.element || event.target.classList.contains('cart-rec-modal__overlay')) {
            this.close();
        }
    }

    onKeydown(event) {
        if (event.key === 'Escape') this.close();
    }

    checkout() {
        const form =
            document.querySelector('#cart-slot-mobile  [data-controller~="floating-cart"] form') ||
            document.querySelector('#cart-slot-desktop [data-controller~="floating-cart"] form') ||
            document.querySelector('[data-controller~="floating-cart"] form');

        if (form) {
            form.submit();
        } else {
            console.warn('[cart-recommendations] Floating cart form not found.');
        }
    }
}
